import { CurrentUserAPI } from 'main/app-state/current-user/current-user.api';
import { Observable } from 'rxjs';
import {
    filter,
    pairwise,
    switchMap,
} from 'rxjs/operators';

import {
    NullableStateManager,
    StateManager,
} from './state-manager';

const watchUser = function <T>(user: CurrentUserAPI, fetch: () => Observable<T | null>, clean: () => Observable<null>) {
    user.value$
        .pipe(
            pairwise(),
            filter(([prevUser, nextUser]) => !prevUser || !nextUser),
            switchMap(([prevUser]) => prevUser ? clean() : fetch()),
        )
        .subscribe();
};

/**
 * A NullableStateManager that reacts to user log in and log out actions.
 */
export abstract class UserStateManager<T> extends NullableStateManager<T> {

    constructor(user: CurrentUserAPI) {
        super();
        watchUser<T>(user, () => this.fetch(), () => this.clean());
    }
    public abstract clean(): Observable<null>;

    public abstract fetch(): Observable<T | null>;
}

/**
 * An ExtendedUserStateManager that is similar to a UserStateManager, but its state is never null,
 * indicating that it may also have limited functionality when the user isn't logged in.
 */
export abstract class ExtendedUserStateManager<T> extends StateManager<T> {

    constructor(user: CurrentUserAPI) {
        super();
        watchUser<T>(user, () => this.fetch(), () => this.clean());
    }
    public abstract clean(): Observable<null>;

    public abstract fetch(): Observable<T>;
}
